import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { AuthenticationComponent } from '../authentication/authentication.component';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css'],
  standalone: true,
  imports: [MaterialModule, RouterModule],
})
export class DialogComponent {
  @Input() autenticationType;

  constructor(public dialog: MatDialog) {}

  openDialog(): void {
    this.dialog.open(DialogTemplate, {
      data: { autenticationType: this.autenticationType },
    });
  }
}

@Component({
  selector: 'dialog-template',
  templateUrl: 'dialog-template.html',
  standalone: true,
  imports: [AuthenticationComponent],
})
export class DialogTemplate {
  constructor(
    public dialogRef: MatDialogRef<DialogTemplate>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
